/**
 * Seed tables, transcribed from `MockFeedService.swift`.
 *
 * Kept as positional tuples matching the Swift originals so the two can be
 * diffed row-for-row. `feedService.ts` is what turns them into Post objects.
 * Every day figure is an offset from today, resolved through mockDate.ts.
 */

/** id, authorId, photo, content, hashtags, location, likes, comments, shares, views, dayOffset, hour, minute */
export type GalleryRow = [
  string,
  string,
  string,
  string,
  string[],
  string | null,
  number,
  number,
  number,
  number,
  number,
  number,
  number,
];

export const GALLERY: GalleryRow[] = [
  [
    "p-alex-1",
    "user-001",
    "alex/alex-1",
    "Quad walks with this guy 🤙",
    ["#campuslife", "#utaustin"],
    "UT Austin Main Mall",
    142,
    8,
    2,
    890,
    -31,
    15,
    30,
  ],
  [
    "p-alex-2",
    "user-001",
    "alex/alex-2",
    "Debugging fuel ☕",
    ["#coffeeshop", "#coding"],
    "Houndstooth Coffee",
    87,
    5,
    1,
    620,
    -28,
    11,
    0,
  ],
  [
    "p-alex-3",
    "user-001",
    "alex/alex-3",
    "Rooftop vibes with the crew. Austin sunsets hit different",
    ["#austin", "#sunset", "#rooftop"],
    "Downtown Austin",
    312,
    24,
    15,
    2840,
    -24,
    19,
    45,
  ],
  [
    "p-alex-4",
    "user-001",
    "alex/alex-4",
    "Taco run got wild",
    ["#tacos", "#foodie", "#austin"],
    "Torchy's Tacos",
    198,
    12,
    4,
    1350,
    -20,
    13,
    20,
  ],
  [
    "p-alex-5",
    "user-001",
    "alex/alex-5",
    "2am commit energy",
    ["#coding", "#latenight", "#cs"],
    null,
    234,
    31,
    8,
    1780,
    -17,
    2,
    15,
  ],
  [
    "p-alex-6",
    "user-001",
    "alex/alex-6",
    "String lights + good people",
    ["#campuslife", "#nightlife"],
    "Speedway",
    156,
    9,
    3,
    1020,
    -14,
    21,
    30,
  ],
  [
    "p-alex-7",
    "user-001",
    "alex/alex-7",
    "Morning mirror check. Woke up like this (barely)",
    ["#selfie", "#morning"],
    null,
    95,
    14,
    0,
    670,
    -11,
    8,
    45,
  ],
  [
    "p-alex-8",
    "user-001",
    "alex/alex-8",
    "Lecture hall daydreaming",
    ["#college", "#cs101"],
    "GDC",
    67,
    4,
    1,
    430,
    -8,
    10,
    0,
  ],
  [
    "p-alex-9",
    "user-001",
    "alex/alex-9",
    "Cards on the quad. I won. They'll deny it",
    ["#campuslife", "#utaustin", "#squad"],
    "UT Austin Main Mall",
    278,
    18,
    6,
    1960,
    -4,
    16,
    0,
  ],
  [
    "p-maya-1",
    "u2",
    "maya/maya-1",
    "Director mode activated 🎬 My actors are actually getting good",
    ["#filmmaking", "#shortfilm", "#utaustin"],
    "UT Film Studio",
    189,
    22,
    7,
    1450,
    -32,
    14,
    0,
  ],
  [
    "p-maya-2",
    "u2",
    "maya/maya-2",
    "Café girlies. We solved zero problems but it felt productive",
    ["#friends", "#café", "#collegelife"],
    "Cuvée Coffee",
    267,
    15,
    5,
    1820,
    -29,
    12,
    30,
  ],
  [
    "p-maya-3",
    "u2",
    "maya/maya-3",
    "Movie night date (with this one)",
    ["#movienight", "#bestfriend"],
    "UT Union Theater",
    321,
    28,
    9,
    2340,
    -25,
    20,
    15,
  ],
  [
    "p-maya-4",
    "u2",
    "maya/maya-4",
    "Twinning wasn't planned I swear",
    ["#roommates", "#ootd", "#mirrorselfie"],
    null,
    198,
    19,
    3,
    1280,
    -21,
    9,
    0,
  ],
  [
    "p-maya-5",
    "u2",
    "maya/maya-5",
    "Editing at midnight is a lifestyle at this point",
    ["#filmstudent", "#editing", "#latenight"],
    null,
    134,
    11,
    2,
    980,
    -18,
    23,
    45,
  ],
  [
    "p-maya-6",
    "u2",
    "maya/maya-6",
    "Rooftop party and I lost my jacket somewhere. Worth it",
    ["#rooftop", "#nightlife", "#austin"],
    "East 6th",
    389,
    32,
    18,
    3120,
    -15,
    23,
    0,
  ],
  [
    "p-maya-7",
    "u2",
    "maya/maya-7",
    "Park day. Someone brought a film camera and now I want one",
    ["#picnic", "#friends", "#analog"],
    "Zilker Park",
    245,
    14,
    6,
    1670,
    -11,
    15,
    0,
  ],
  [
    "p-maya-8",
    "u2",
    "maya/maya-8",
    "Presented my short film analysis today. Shaking the whole time but we did it",
    ["#filmstudies", "#presentation"],
    null,
    156,
    20,
    4,
    1100,
    -7,
    11,
    30,
  ],
  [
    "p-maya-9",
    "u2",
    "maya/maya-9",
    "Morning campus walks with my favorite person",
    ["#morningwalk", "#campus", "#bestfriend"],
    "UT Austin Speedway",
    287,
    16,
    5,
    1890,
    -3,
    9,
    15,
  ],
  [
    "p-jamie-1",
    "u1",
    "jamie/jamie-1",
    "Pair programming hits different when your partner actually reads the docs",
    ["#coding", "#cs", "#pairprogramming"],
    "GDC Lab",
    112,
    15,
    3,
    780,
    -30,
    16,
    0,
  ],
  [
    "p-jamie-2",
    "u1",
    "jamie/jamie-2",
    "Found this in the philosophy section. They get it",
    ["#bookstore", "#books", "#reading"],
    "Half Price Books",
    89,
    7,
    2,
    540,
    -27,
    14,
    30,
  ],
  [
    "p-jamie-3",
    "u1",
    "jamie/jamie-3",
    "Rain campus aesthetic. No I did not plan this photo",
    ["#rainy", "#campus", "#aesthetic"],
    "UT Austin",
    156,
    10,
    8,
    1340,
    -23,
    17,
    0,
  ],
  [
    "p-jamie-4",
    "u1",
    "jamie/jamie-4",
    "Café window seat is my office now. Don't talk to me I'm thinking",
    ["#café", "#studying", "#introvert"],
    "Epoch Coffee",
    134,
    9,
    4,
    920,
    -20,
    11,
    0,
  ],
  [
    "p-jamie-5",
    "u1",
    "jamie/jamie-5",
    "Trying to explain recursion to actual humans",
    ["#cs", "#whiteboard", "#studying"],
    "PCL Study Room",
    98,
    12,
    2,
    670,
    -16,
    15,
    30,
  ],
  [
    "p-jamie-6",
    "u1",
    "jamie/jamie-6",
    "36 hours no sleep but we placed 3rd. Worth every line of spaghetti code",
    ["#hackathon", "#coding", "#teamwork"],
    "GDC Atrium",
    287,
    34,
    14,
    2450,
    -12,
    18,
    0,
  ],
  [
    "p-jamie-7",
    "u1",
    "jamie/jamie-7",
    "Mirror check. Same 3 colors as always",
    ["#ootd", "#mirrorselfie"],
    null,
    76,
    8,
    0,
    480,
    -9,
    8,
    30,
  ],
  [
    "p-jamie-8",
    "u1",
    "jamie/jamie-8",
    "This painting has been staring at me for 20 minutes and I think it's winning",
    ["#art", "#museum", "#weekend"],
    "Blanton Museum",
    145,
    11,
    5,
    1080,
    -6,
    14,
    0,
  ],
  [
    "p-jamie-9",
    "u1",
    "jamie/jamie-9",
    "Bench computing. The vibe is immaculate",
    ["#laptop", "#campus", "#coding"],
    "UT Austin",
    67,
    3,
    1,
    410,
    -2,
    13,
    45,
  ],
  [
    "p-sophie-1",
    "u4",
    "sophie/sophie-1",
    "Study date with my girl. Psych textbooks stacking up",
    ["#studying", "#psychology", "#library"],
    "PCL Library",
    178,
    14,
    3,
    1290,
    -31,
    13,
    0,
  ],
  [
    "p-sophie-2",
    "u4",
    "sophie/sophie-2",
    "Campus walks and iced coffee. The uniform",
    ["#ootd", "#campusstyle", "#icedcoffee"],
    "UT Austin",
    412,
    47,
    12,
    4230,
    -28,
    11,
    30,
  ],
  [
    "p-sophie-3",
    "u4",
    "sophie/sophie-3",
    "Café hangs with my girls ☕",
    ["#café", "#friends", "#braces"],
    "Jo's Coffee",
    289,
    31,
    7,
    2340,
    -24,
    14,
    0,
  ],
  [
    "p-sophie-4",
    "u4",
    "sophie/sophie-4",
    "Same café, different angle. We stayed too long",
    ["#café", "#friends", "#collegelife"],
    "Jo's Coffee",
    187,
    12,
    3,
    1230,
    -20,
    14,
    0,
  ],
  [
    "p-sophie-5",
    "u4",
    "sophie/sophie-5",
    "Found a campus cat AND a cute outfit day? Universe is kind",
    ["#campuscat", "#ootd", "#campus"],
    "UT Austin",
    398,
    35,
    11,
    3450,
    -16,
    15,
    0,
  ],
  [
    "p-sophie-7",
    "u4",
    "sophie/sophie-7",
    "Used bookstore treasure hunting. Reaching for the top shelf",
    ["#bookstore", "#vintage", "#reading"],
    "Monkeywrench Books",
    213,
    18,
    5,
    1560,
    -10,
    12,
    0,
  ],
  [
    "p-sophie-8",
    "u4",
    "sophie/sophie-8",
    "Study circle on the floor. Highlighters out, brains off",
    ["#studying", "#friends", "#collegelife"],
    null,
    187,
    12,
    3,
    1230,
    -7,
    19,
    0,
  ],
  [
    "p-sophie-9",
    "u4",
    "sophie/sophie-9",
    "Going out fit check 🪞",
    ["#ootd", "#goingout", "#mirrorselfie"],
    null,
    489,
    52,
    16,
    5120,
    -4,
    20,
    30,
  ],
  [
    "p-sophie-10",
    "u4",
    "sophie/sophie-10",
    "Squad pic under the arch. Lavender set = my uniform at this point",
    ["#squad", "#utaustin", "#friends"],
    "UT Tower",
    345,
    26,
    8,
    2780,
    -1,
    16,
    0,
  ],
  [
    "p-zara-1",
    "u10",
    "zara/zara-1",
    "Spoke at the freshman leadership forum today. Still shaking",
    ["#leadership", "#publicspeaking"],
    "UT Union Ballroom",
    234,
    28,
    12,
    2100,
    -32,
    18,
    30,
  ],
  [
    "p-zara-2",
    "u10",
    "zara/zara-2",
    "Rooftop nights with my girls. Pink set was a choice",
    ["#rooftop", "#nightout", "#austin"],
    "East 6th Rooftop",
    478,
    54,
    19,
    5340,
    -29,
    23,
    0,
  ],
  [
    "p-zara-3",
    "u10",
    "zara/zara-3",
    "Campus power walk. Blazer + band tee + mini skirt = the formula",
    ["#campus", "#ootd", "#miniskirt"],
    "UT Austin Speedway",
    367,
    39,
    10,
    3210,
    -25,
    12,
    0,
  ],
  [
    "p-zara-4",
    "u10",
    "zara/zara-4",
    'Me in poli sci: "actually I think you\'re wrong" (I was right)',
    ["#polisci", "#debate", "#college"],
    null,
    198,
    42,
    8,
    1780,
    -21,
    14,
    15,
  ],
  [
    "p-zara-5",
    "u10",
    "zara/zara-5",
    "Besties. She's chaotic and I'm worse",
    ["#bestfriend", "#selfie", "#morningvibes"],
    null,
    312,
    22,
    5,
    2340,
    -18,
    9,
    0,
  ],
  [
    "p-darius-1",
    "u5",
    "darius/darius-1",
    "Pool day with the boys. No shirts no problems",
    ["#pool", "#shirtless", "#summer"],
    "West Campus Pool",
    412,
    34,
    12,
    3560,
    -30,
    14,
    0,
  ],
  [
    "p-darius-2",
    "u5",
    "darius/darius-2",
    "Arm day with my spotter. He said I could do 10 more. He lied",
    ["#gym", "#fitness", "#gains"],
    "Gregory Gym",
    234,
    28,
    5,
    1890,
    -27,
    17,
    30,
  ],
  [
    "p-darius-3",
    "u5",
    "darius/darius-3",
    "Tailgate squad deep. 🤘 Hook 'em",
    ["#tailgate", "#utfootball", "#gameday"],
    "DKR Stadium Lot",
    478,
    42,
    22,
    4560,
    -23,
    11,
    0,
  ],
  [
    "p-darius-4",
    "u5",
    "darius/darius-4",
    "Campus walk energy. All black everything",
    ["#ootd", "#campuslife", "#streetwear"],
    "UT Austin",
    267,
    19,
    7,
    2100,
    -20,
    12,
    30,
  ],
  [
    "p-darius-5",
    "u5",
    "darius/darius-5",
    'Business presentation but make it swole. Professor said "nice polo" and I know she meant the arms',
    ["#business", "#presentation", "#college"],
    "McCombs",
    189,
    32,
    9,
    1560,
    -16,
    10,
    0,
  ],
  [
    "p-darius-6",
    "u5",
    "darius/darius-6",
    "Party pic. She's cool, I'm cooler",
    ["#party", "#nightout", "#selfie"],
    null,
    398,
    38,
    11,
    3230,
    -13,
    23,
    30,
  ],
  [
    "p-darius-7",
    "u5",
    "darius/darius-7",
    "Beach sunset with the crew. Miss this already",
    ["#beach", "#sunset", "#friends"],
    "Port Aransas",
    345,
    22,
    14,
    2890,
    -10,
    18,
    45,
  ],
  [
    "p-darius-8",
    "u5",
    "darius/darius-8",
    "Pickup game don't count but I still went hard",
    ["#basketball", "#hoops", "#outdoor"],
    "Gregory Gym Courts",
    289,
    26,
    8,
    2340,
    -6,
    16,
    0,
  ],
  [
    "p-darius-9",
    "u5",
    "darius/darius-9",
    "Birthday dinner toast. 20 incoming. These people are everything",
    ["#birthday", "#squad", "#dinner"],
    "Uchi Austin",
    534,
    56,
    18,
    4780,
    -2,
    20,
    0,
  ],
  [
    "p-priya-1",
    "u6",
    "priya/priya-1",
    "Lab partner and I are basically scientists now",
    ["#biology", "#lablife", "#science"],
    "Welch Hall Bio Lab",
    98,
    8,
    2,
    620,
    -31,
    11,
    0,
  ],
  [
    "p-priya-2",
    "u6",
    "priya/priya-2",
    "Library grind. Color-coded notes or it didn't happen",
    ["#studying", "#premed", "#library"],
    "PCL Library",
    134,
    12,
    4,
    890,
    -28,
    19,
    0,
  ],
  [
    "p-priya-3",
    "u6",
    "priya/priya-3",
    "Diwali on campus was beautiful this year. My people 💛",
    ["#diwali", "#culture", "#indian", "#utaustin"],
    "UT Union",
    378,
    34,
    22,
    3450,
    -24,
    18,
    0,
  ],
  [
    "p-priya-4",
    "u6",
    "priya/priya-4",
    "Study group carrying me through orgo. Whiteboard queen era",
    ["#studygroup", "#organicchemistry", "#premed"],
    null,
    112,
    15,
    3,
    780,
    -20,
    20,
    30,
  ],
  [
    "p-priya-5",
    "u6",
    "priya/priya-5",
    "Campus walks with this one. She keeps me sane",
    ["#friends", "#campuswalk", "#college"],
    "UT Austin",
    156,
    10,
    2,
    1020,
    -17,
    12,
    0,
  ],
  [
    "p-priya-6",
    "u6",
    "priya/priya-6",
    "Garden bench and a textbook. My happy place, honestly",
    ["#reading", "#nature", "#campus"],
    "UT Campus Garden",
    87,
    6,
    1,
    540,
    -14,
    15,
    30,
  ],
  [
    "p-brittany-1",
    "u8",
    "brittany/brittany-1",
    "Art fair finds with my girls. That painting is coming home with me",
    ["#artfair", "#art", "#friends"],
    "East Austin Art Walk",
    198,
    16,
    5,
    1340,
    -31,
    14,
    0,
  ],
  [
    "p-brittany-2",
    "u8",
    "brittany/brittany-2",
    "Saturday night fit. Wrap dress era continues",
    ["#party", "#ootd", "#wrapdress"],
    null,
    267,
    24,
    7,
    2100,
    -28,
    22,
    0,
  ],
  [
    "p-brittany-3",
    "u8",
    "brittany/brittany-3",
    "Mirror selfie with my roomie. She stole my scrunchie again",
    ["#roommates", "#mirrorselfie", "#dormlife"],
    null,
    189,
    18,
    3,
    1280,
    -24,
    10,
    0,
  ],
  [
    "p-brittany-4",
    "u8",
    "brittany/brittany-4",
    "Whispering in lecture is an art form",
    ["#braids", "#lecture", "#collegelife"],
    null,
    134,
    12,
    2,
    890,
    -21,
    11,
    30,
  ],
  [
    "p-brittany-5",
    "u8",
    "brittany/brittany-5",
    "Dancing at the cultural fest!! The off-shoulder top is giving what it's supposed to give",
    ["#dancing", "#culture", "#festival"],
    "UT Union Patio",
    345,
    32,
    14,
    2890,
    -18,
    17,
    0,
  ],
  [
    "p-brittany-6",
    "u8",
    "brittany/brittany-6",
    "Homework mode. String lights, snacks, and a side of procrastination",
    ["#studying", "#dormlife", "#chill"],
    null,
    98,
    7,
    1,
    540,
    -15,
    21,
    30,
  ],
  [
    "p-brittany-7",
    "u8",
    "brittany/brittany-7",
    "Brunch with my favorite people on earth",
    ["#brunch", "#mimosas", "#friends"],
    "Paperboy",
    289,
    22,
    6,
    2120,
    -12,
    11,
    0,
  ],
  [
    "p-brittany-8",
    "u8",
    "brittany/brittany-8",
    "Fashion show date 🤩 Leopard jumpsuit was THE move",
    ["#fashionshow", "#leopardprint", "#style"],
    "UT Union Ballroom",
    312,
    28,
    10,
    2560,
    -9,
    20,
    0,
  ],
  [
    "p-brittany-9",
    "u8",
    "brittany/brittany-9",
    "Study session vibes. She's on her phone obviously",
    ["#studying", "#dormlife", "#chill"],
    null,
    98,
    7,
    1,
    540,
    -6,
    21,
    30,
  ],
  [
    "p-brittany-10",
    "u8",
    "brittany/brittany-10",
    "TikTok attempt #47. This one might actually be good",
    ["#tiktok", "#dance", "#friends"],
    null,
    267,
    34,
    12,
    2340,
    -3,
    19,
    0,
  ],
  [
    "p-carlos-1",
    "u7",
    "carlos/carlos-1",
    "Grill master at the tailgate. Someone get this man an apron",
    ["#tailgate", "#grilling", "#utaustin"],
    "DKR Stadium Lot",
    234,
    18,
    8,
    1780,
    -30,
    12,
    0,
  ],
  [
    "p-carlos-2",
    "u7",
    "carlos/carlos-2",
    "Hawaiian shirt was a vibe. No one asked but everyone noticed",
    ["#houseparty", "#hawaiianshirt", "#party"],
    null,
    312,
    26,
    9,
    2450,
    -27,
    23,
    0,
  ],
  [
    "p-carlos-3",
    "u7",
    "carlos/carlos-3",
    "Pong champs. Undefeated tonight (don't check with anyone else)",
    ["#beerpong", "#party", "#champs"],
    null,
    278,
    32,
    7,
    2100,
    -23,
    22,
    30,
  ],
  [
    "p-carlos-4",
    "u7",
    "carlos/carlos-4",
    "Game day with the boys 🤘 Hook 'em",
    ["#utfootball", "#gameday", "#groupselfie"],
    "DKR Stadium",
    389,
    28,
    15,
    3120,
    -20,
    14,
    0,
  ],
  [
    "p-carlos-5",
    "u7",
    "carlos/carlos-5",
    "2am fast food run. This is what college is actually about",
    ["#latenight", "#fastfood", "#friends"],
    "Whataburger",
    345,
    42,
    11,
    2890,
    -17,
    2,
    30,
  ],
  [
    "p-carlos-6",
    "u7",
    "carlos/carlos-6",
    "Golden hour. Leaning on things is my whole personality",
    ["#goldenhour", "#vibes", "#car"],
    null,
    156,
    12,
    3,
    1020,
    -14,
    18,
    30,
  ],
  [
    "p-carlos-7",
    "u7",
    "carlos/carlos-7",
    "Marketing group project. I brought the snacks, they brought the brains",
    ["#marketing", "#groupproject", "#college"],
    null,
    89,
    8,
    1,
    540,
    -11,
    14,
    0,
  ],
  [
    "p-carlos-8",
    "u7",
    "carlos/carlos-8",
    "Festival was insane. Girl on my shoulders had the best view",
    ["#musicfestival", "#concert", "#austin"],
    "Zilker Park",
    467,
    38,
    24,
    4560,
    -7,
    19,
    0,
  ],
  [
    "p-carlos-9",
    "u7",
    "carlos/carlos-9",
    "Blew out the candles for my boy. Cake was mid but the company was elite",
    ["#birthday", "#friends", "#party"],
    null,
    289,
    22,
    6,
    2100,
    -3,
    21,
    0,
  ],
  [
    "p-tyler-1",
    "u3",
    "tyler/tyler-1",
    "Post-workout with the bro. Looking absolutely yoked",
    ["#gym", "#fitness", "#shirtless", "#gains"],
    "Gregory Gym",
    312,
    24,
    8,
    2560,
    -31,
    18,
    0,
  ],
  [
    "p-tyler-2",
    "u3",
    "tyler/tyler-2",
    "Party with the squad. Tank top mandatory",
    ["#party", "#squad", "#nightout"],
    "West Campus",
    389,
    32,
    12,
    3120,
    -28,
    23,
    30,
  ],
  [
    "p-tyler-3",
    "u3",
    "tyler/tyler-3",
    "Arm day never skipped. Spotter in the graphic tee",
    ["#gym", "#fitness", "#gains"],
    "UT Rec Center",
    234,
    28,
    6,
    1890,
    -24,
    16,
    0,
  ],
  [
    "p-tyler-4",
    "u3",
    "tyler/tyler-4",
    "Kinesiology lab getting nerdy. Yes I can be both",
    ["#kinesiology", "#anatomy", "#college"],
    "Bellmont Hall",
    98,
    8,
    2,
    620,
    -20,
    11,
    0,
  ],
  [
    "p-tyler-5",
    "u3",
    "tyler/tyler-5",
    "Dorm life with the boys. Shaker cup is always in frame",
    ["#dormlife", "#roommate", "#college"],
    "Jester West",
    178,
    18,
    4,
    1230,
    -16,
    19,
    0,
  ],
];

/** id, authorId, photo, courseId, courseCode, title, content, hashtags, likes, comments, shares, views, dayOffset, hour */
export type LearnRow = [
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string[],
  number,
  number,
  number,
  number,
  number,
  number,
];

export const LEARN: LearnRow[] = [
  [
    "learn-cs101-1",
    "u1",
    "jamie/jamie-5",
    "cs101",
    "CS 101",
    "Recursion, explained on a whiteboard",
    "Base case first, then trust the recursive call. Once that clicked the whole PA3 linked list thing got way easier.",
    ["#cs101", "#recursion", "#datastructures"],
    214,
    27,
    9,
    1840,
    -6,
    15,
  ],
  [
    "learn-cs101-2",
    "u1",
    "jamie/jamie-1",
    "cs101",
    "CS 101",
    "Pointer diagrams before you write any code",
    "Draw the nodes and the arrows on paper. Every linked list bug I've had was a diagram I skipped.",
    ["#cs101", "#pointers", "#studytips"],
    168,
    19,
    6,
    1420,
    -4,
    11,
  ],
  [
    "learn-cs101-3",
    "u1",
    "jamie/jamie-6",
    "cs101",
    "CS 101",
    "Dr. Williams' midterm review, condensed",
    "Everything from the review session in one page — traversal, insertion, deletion, and the two Big-O questions she always asks.",
    ["#cs101", "#midterm", "#notes"],
    302,
    41,
    22,
    2670,
    -2,
    20,
  ],
  [
    "learn-eng102-1",
    "u2",
    "maya/maya-8",
    "eng102",
    "ENG 102",
    "How I structure a rhetorical analysis",
    "Claim, evidence, warrant — Prof. Liu marks you down every time the warrant is missing. Here's the outline I use now.",
    ["#eng102", "#rhetoric", "#writing"],
    147,
    16,
    8,
    1180,
    -5,
    13,
  ],
  [
    "learn-eng102-2",
    "u8",
    "brittany/brittany-6",
    "eng102",
    "ENG 102",
    "Research paper draft: the checklist",
    "Thesis in the first paragraph, sources annotated, no block quotes over four lines. Saved me before the last deadline.",
    ["#eng102", "#researchpaper", "#draft"],
    193,
    24,
    11,
    1560,
    -3,
    21,
  ],
  [
    "learn-eng102-3",
    "u10",
    "zara/zara-4",
    "eng102",
    "ENG 102",
    "Arguing without sounding like a jerk",
    "Concede the strongest counterargument early. It reads as confidence, and Prof. Liu grades for it.",
    ["#eng102", "#argument", "#writing"],
    256,
    38,
    14,
    2210,
    -1,
    14,
  ],
  [
    "learn-math1b-1",
    "u6",
    "priya/priya-4",
    "math1b",
    "MATH 1B",
    "Integration by parts without the panic",
    "LIATE picks your u every time. Worked through four problems from PS5 on the whiteboard.",
    ["#math1b", "#calculus", "#integration"],
    231,
    33,
    17,
    1990,
    -7,
    20,
  ],
  [
    "learn-math1b-2",
    "u4",
    "sophie/sophie-1",
    "math1b",
    "MATH 1B",
    "Problem set 5, walked through",
    "The trig substitution ones are the whole difficulty. Numbers 7 and 9 are the same problem twice.",
    ["#math1b", "#problemset", "#studygroup"],
    178,
    29,
    7,
    1470,
    -4,
    13,
  ],
  [
    "learn-math1b-3",
    "u6",
    "priya/priya-2",
    "math1b",
    "MATH 1B",
    "Everything on Dr. Vasquez's midterm",
    "Series convergence, integration techniques, and one volume-of-revolution problem. Color-coded, obviously.",
    ["#math1b", "#midterm", "#notes"],
    341,
    47,
    26,
    3120,
    -1,
    19,
  ],
];

/** id, title, content, dayOffset, hour, endDayOffset, endHour, endMinute, location, isVirtual, attendees, isRSVPd, isInvited, invitedByIdx, authorIdx */
export type EventRow = [
  string,
  string,
  string,
  number,
  number,
  number,
  number,
  number,
  string | null,
  boolean,
  number,
  boolean,
  boolean,
  number | null,
  number,
];

export const EVENTS: EventRow[] = [
  [
    "ev-1",
    "CS Freshman Mixer",
    "Meet fellow CS freshmen! Food, games, and networking with upperclassmen mentors.",
    -11,
    18,
    -11,
    21,
    0,
    "GDC Atrium",
    false,
    87,
    false,
    false,
    null,
    0,
  ],
  [
    "ev-2",
    "Longhorn Trivia Night",
    "Test your UT knowledge — prizes for top 3 teams. Bring your crew!",
    -6,
    19,
    -6,
    21,
    30,
    "Cactus Cafe",
    false,
    42,
    false,
    false,
    null,
    4,
  ],
  [
    "ev-3",
    "Black History Month Showcase",
    "Celebrate BHM with performances, spoken word, and soul food.",
    -4,
    17,
    -4,
    20,
    0,
    "Union Ballroom",
    false,
    156,
    false,
    false,
    null,
    7,
  ],
  [
    "ev-4",
    "Study Abroad Fair",
    "Learn about summer programs worldwide. Reps from 30+ countries.",
    5,
    14,
    5,
    17,
    0,
    "Union Ballroom",
    false,
    67,
    false,
    false,
    null,
    1,
  ],
  [
    "ev-5",
    "Virtual Game Night",
    "Among Us, Jackbox, and more! Hop on Discord and vibe.",
    7,
    20,
    7,
    23,
    0,
    null,
    true,
    23,
    false,
    false,
    null,
    3,
  ],
  [
    "ev-6",
    "Spring Concert",
    "Featuring local Austin bands. Free for all freshmen!",
    10,
    19,
    10,
    22,
    0,
    "Main Mall Stage",
    false,
    312,
    true,
    false,
    null,
    5,
  ],
  [
    "ev-7",
    "Freshman Council Town Hall",
    "Voice your ideas for campus improvements. Free pizza.",
    12,
    18,
    12,
    19,
    30,
    "GDC 2.216",
    false,
    34,
    false,
    false,
    null,
    1,
  ],
  [
    "ev-8",
    "Gregory Gym Open House",
    "Free fitness classes, rock wall, and pool access all day.",
    14,
    10,
    14,
    18,
    0,
    "Gregory Gym",
    false,
    145,
    false,
    false,
    null,
    6,
  ],
  [
    "ev-9",
    "Entrepreneur Speaker Series",
    "Y Combinator alumni share startup stories. Q&A after.",
    16,
    17,
    16,
    19,
    0,
    "Rowling Hall 360",
    false,
    89,
    false,
    false,
    null,
    8,
  ],
  [
    "ev-10",
    "Outdoor Movie Night",
    "Watching 'Spider-Verse' on the Main Mall. BYO blanket.",
    17,
    20,
    17,
    22,
    30,
    "Main Mall",
    false,
    201,
    false,
    false,
    null,
    0,
  ],
  [
    "ev-11",
    "Longhorn Hackathon",
    "24-hour hackathon — build anything. $5K in prizes.",
    20,
    18,
    21,
    18,
    0,
    "GDC Atrium",
    false,
    178,
    false,
    false,
    null,
    3,
  ],
  [
    "ev-12",
    "Spring Fest",
    "End-of-March blowout — food trucks, live music, inflatables.",
    23,
    12,
    23,
    22,
    0,
    "Clark Field",
    false,
    520,
    false,
    false,
    null,
    9,
  ],
];

/** id, title, content, category, dayOffset, hour, endDayOffset, endHour, endMinute, location, respondents, isJoined, authorIdx */
export type ActivityRow = [
  string,
  string,
  string,
  string,
  number | null,
  number,
  number | null,
  number,
  number,
  string | null,
  number,
  boolean,
  number,
];

export const ACTIVITIES: ActivityRow[] = [
  [
    "act-1",
    "Gym buddy — Gregory Gym M/W/F",
    "I go to Gregory Gym Monday, Wednesday, Friday mornings around 7am. Looking for someone to lift with — any experience level!",
    "gym",
    4,
    7,
    4,
    8,
    30,
    "Gregory Gym",
    3,
    false,
    2,
  ],
  [
    "act-2",
    "Pickup basketball this Saturday",
    "Need 2 more for a 5v5 at Clark Field courts. All skill levels welcome!",
    "basketball",
    9,
    16,
    9,
    18,
    0,
    "Clark Field Courts",
    8,
    false,
    4,
  ],
  [
    "act-3",
    "Barton Creek Greenbelt hike",
    "Weekend hike at the Greenbelt — moderate trail, about 4 miles. Carpooling from campus.",
    "hiking",
    10,
    9,
    10,
    13,
    0,
    "Barton Creek Greenbelt",
    12,
    false,
    6,
  ],
  [
    "act-4",
    "Sand volleyball at Whitaker",
    "Looking for people to play sand volleyball Thursday evenings. Casual, just for fun.",
    "volleyball",
    8,
    17,
    8,
    19,
    0,
    "Whitaker Fields",
    6,
    false,
    0,
  ],
  [
    "act-5",
    "Morning run group — Town Lake",
    "6am runs around Town Lake trail, 3-4 miles. We go Tues/Thurs. All paces welcome.",
    "running",
    5,
    6,
    5,
    7,
    0,
    "Town Lake Trail",
    5,
    false,
    8,
  ],
  [
    "act-6",
    "Soccer scrimmage on Sundays",
    "Informal soccer games every Sunday at Whitaker. Show up and play!",
    "soccer",
    11,
    14,
    11,
    16,
    0,
    "Whitaker Fields",
    14,
    false,
    1,
  ],
  [
    "act-7",
    "Chess club meetups",
    "Looking for chess players on campus. We meet at the Union most afternoons — all ratings welcome.",
    "chess",
    null,
    0,
    null,
    0,
    0,
    "Texas Union",
    7,
    false,
    3,
  ],
  [
    "act-8",
    "Smash Bros tournament crew",
    "We run weekly Smash Ultimate brackets in Jester. Come compete or just hang!",
    "video games",
    null,
    0,
    null,
    0,
    0,
    "Jester West Lobby",
    15,
    false,
    5,
  ],
  [
    "act-9",
    "Photography walks around campus",
    "Exploring campus with cameras — phone or DSLR, doesn't matter. Share spots and tips.",
    "photography",
    null,
    0,
    null,
    0,
    0,
    null,
    4,
    false,
    7,
  ],
  [
    "act-10",
    "Study group — Intro to CS",
    "CS 312 study sessions. We meet at PCL when exams are coming up.",
    "study",
    null,
    0,
    null,
    0,
    0,
    "PCL",
    9,
    false,
    9,
  ],
  [
    "act-11",
    "Rock climbing partners",
    "Looking for people to climb with at the Gregory Gym wall. I have gear to share.",
    "climbing",
    null,
    0,
    null,
    0,
    0,
    "Gregory Gym",
    3,
    false,
    2,
  ],
  [
    "act-12",
    "Yoga on the Main Mall",
    "Free outdoor yoga sessions — bring a mat. All levels, very chill.",
    "yoga",
    null,
    0,
    null,
    0,
    0,
    "Main Mall",
    8,
    false,
    6,
  ],
];

/** id, title, content, category, dayOffset, hour, endDayOffset, endHour, endMinute, location, isOpen, acceptedByIdx, authorIdx */
export type RivalRow = [
  string,
  string,
  string,
  string,
  number | null,
  number,
  number | null,
  number,
  number,
  string | null,
  boolean,
  number | null,
  number,
];

export const RIVALS: RivalRow[] = [
  [
    "riv-1",
    "1v1 Basketball — who's got game?",
    "Looking for a competitive 1v1 at Gregory Gym courts. Bring your A game, I don't lose easy.",
    "basketball",
    6,
    17,
    6,
    18,
    0,
    "Gregory Gym Courts",
    true,
    null,
    4,
  ],
  [
    "riv-2",
    "Chess match — rated 1200+",
    "Looking for someone rated 1200+ on chess.com for a best-of-3 OTB match. Loser buys coffee.",
    "chess",
    8,
    15,
    8,
    17,
    0,
    "Texas Union",
    true,
    null,
    3,
  ],
  [
    "riv-3",
    "Tennis singles challenge",
    "I played varsity in high school. Looking for a real match — best of 3 sets.",
    "tennis",
    13,
    10,
    13,
    12,
    0,
    "Penick-Allison Courts",
    true,
    null,
    1,
  ],
  [
    "riv-4",
    "Sprint race — 100m dash",
    "Track is open Saturday mornings. Let's see who's the fastest freshman. Phone-timed.",
    "running",
    9,
    8,
    9,
    9,
    0,
    "Mike A. Myers Stadium",
    true,
    null,
    8,
  ],
  [
    "riv-5",
    "Ping pong showdown",
    "I'm undefeated at the Union tables. Come take my crown. Best of 5.",
    "ping pong",
    15,
    12,
    15,
    13,
    0,
    "Texas Union",
    true,
    null,
    5,
  ],
  [
    "riv-6",
    "FIFA 25 — 1v1 best of 5",
    "Think you can beat me? I run Man City. Pull up whenever.",
    "video games",
    null,
    0,
    null,
    0,
    0,
    null,
    true,
    null,
    7,
  ],
  [
    "riv-7",
    "Pool / billiards challenge",
    "Looking for someone decent at 8-ball. Union pool tables, any evening.",
    "billiards",
    null,
    0,
    null,
    0,
    0,
    "Texas Union",
    true,
    null,
    9,
  ],
  [
    "riv-8",
    "Arm wrestling champion",
    "I've beaten everyone in my dorm. Who wants to try? Jester lobby, name the time.",
    "arm wrestling",
    null,
    0,
    null,
    0,
    0,
    "Jester West",
    true,
    null,
    2,
  ],
  [
    "riv-9",
    "Rock climbing race",
    "First to top the hardest route at Gregory wall wins. Any takers?",
    "climbing",
    null,
    0,
    null,
    0,
    0,
    "Gregory Gym",
    true,
    null,
    6,
  ],
  [
    "riv-10",
    "Freestyle rap battle",
    "I write bars. Looking for someone who can actually spit. Cypher at the Union.",
    "freestyle",
    null,
    0,
    null,
    0,
    0,
    "Texas Union",
    true,
    null,
    4,
  ],
  [
    "riv-11",
    "Mario Kart showdown",
    "I'm a menace on Rainbow Road. Best of 7, any character. Jester common room.",
    "video games",
    null,
    0,
    null,
    0,
    0,
    "Jester West",
    true,
    null,
    0,
  ],
];

/** id, title, content, amount, provider, eligibility, deadlineOffset, appURL, authorIdx */
export type ScholarshipRow = [
  string,
  string,
  string,
  number,
  string,
  string,
  number,
  string,
  number,
];

export const SCHOLARSHIPS: ScholarshipRow[] = [
  [
    "sch-1",
    "Texas Exes Freshman Scholarship",
    "Awarded to incoming freshmen who demonstrate academic excellence and community involvement. Open to all majors.",
    3000,
    "Texas Exes Alumni Association",
    "3.5+ GPA, full-time freshman, UT Austin enrolled",
    41,
    "https://texasexes.org/scholarships",
    0,
  ],
  [
    "sch-2",
    "STEM Diversity Scholarship",
    "Supporting underrepresented students in STEM fields. Covers tuition and lab fees for one semester.",
    2500,
    "UT College of Natural Sciences",
    "Declared STEM major, first-generation or underrepresented background",
    27,
    "https://cns.utexas.edu/scholarships",
    5,
  ],
  [
    "sch-3",
    "Longhorn Leadership Award",
    "Recognizing freshmen who show outstanding leadership potential through campus involvement.",
    1500,
    "Division of Student Affairs",
    "Active in at least one student org, minimum 3.0 GPA",
    57,
    "https://deanofstudents.utexas.edu/awards",
    1,
  ],
  [
    "sch-4",
    "Creative Arts Fellowship",
    "For freshmen pursuing creative disciplines — writing, visual arts, music, film, or theater.",
    2000,
    "College of Fine Arts",
    "Portfolio submission required, enrolled in fine arts course",
    46,
    "https://finearts.utexas.edu/fellowships",
    7,
  ],
];

/** id, title, content, employer, compensation, remote, location, deadlineOffset, appURL, authorIdx */
export type JobRow = [
  string,
  string,
  string,
  string,
  string,
  boolean,
  string | null,
  number,
  string,
  number,
];

export const JOBS: JobRow[] = [
  [
    "job-1",
    "CS Tutoring — Intro Courses",
    "Tutor freshmen in CS 312 and CS 314. Flexible hours, great for building your resume and helping fellow Longhorns.",
    "UT Computer Science Dept",
    "$20/hr",
    false,
    "GDC Tutoring Lab",
    36,
    "https://cs.utexas.edu/jobs",
    3,
  ],
  [
    "job-2",
    "Library Student Assistant",
    "Shelving, front desk help, and supporting study room reservations. Quiet environment, study-friendly shifts.",
    "Perry-Castañeda Library",
    "$15/hr",
    false,
    "PCL",
    20,
    "https://lib.utexas.edu/jobs",
    9,
  ],
  [
    "job-3",
    "Rec Sports Lifeguard",
    "Certified lifeguards needed for Gregory Gym pool. Morning and evening shifts available. CPR cert required.",
    "RecSports",
    "$16/hr",
    false,
    "Gregory Gym Pool",
    25,
    "https://recsports.utexas.edu/jobs",
    6,
  ],
  [
    "job-4",
    "Campus Tour Guide",
    "Lead prospective students and families on campus tours. Great public speaking experience — training provided.",
    "Office of Admissions",
    "$14/hr",
    false,
    "Main Building",
    31,
    "https://admissions.utexas.edu/tours/apply",
    2,
  ],
];
